<div fxLayout="row" fxFlexFill>
    <div fxLayout="column" fxFlexFill>
        <div fxLayout="row" fxFlexFill *ngIf="isEditando">
            <div ngModelGroup="comboConsultaBancoTabela_{{pinRandom}}" fxFlex="100">
                <combo-consulta-banco [showDisplayId]="false"
                                      [obrigatorio]="true"
                                      [selecionado]="conteudo.consultaBanco"
                                      [label]="'Tabela'"
                                      (valorChange)="onValorChangeConsultaBanco($event)"
                                      [tipoConsulta]="'L'"
                                      [desabilitado]="camposDesabilitados">
                </combo-consulta-banco>
            </div>

            <div style="margin-left: 26px;">
                <mat-checkbox color="primary" title="Agrupar Tabela"
                              name="agruparTabela_{{pinRandom}}"
                              [(ngModel)]="conteudo.agruparTabela" style="margin-top: 15px" [disabled]="camposDesabilitados">
                    Agrupar Tabela
                </mat-checkbox>
            </div>
        </div>

        <div fxLayout="row" fxFlexFill *ngIf="isEditando && colunasTabela?.length > 0">
            <mat-form-field fxFlex="100">
                <mat-select placeholder="Colunas da Tabela"
                            [(ngModel)]="colunasTabelaSelecionadas"
                            name="colunasTabela_{{pinRandom}}"
                            multiple required
                            (selectionChange)="onValorChangeConsultaColunaBanco()" [disabled]="camposDesabilitados">
                    <mat-option *ngFor="let m of colunasTabela" [value]="m">
                        {{ m.nome }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-card appearance="outlined" class="bordas" *ngIf="colunasTabelaSelecionadas?.length > 0">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="tituloCardTabela">
                <div>
                    Tabela
                </div>
                <div>
                    <button mat-icon-button
                            [style.opacity]="isEditando ? '1' : '0'"
                            [style.cursor]="isEditando ? 'pointer' : 'default'"
                            (click)="isEditando && abrirDialogLarguraColuna()"
                            *ngIf="!camposDesabilitados">
                        <mat-icon>settings</mat-icon>
                    </button>
                    <button mat-icon-button
                            [style.opacity]="isEditando ? '1' : '0'"
                            [style.cursor]="isEditando ? 'pointer' : 'default'"
                            (click)="isEditando && chamaCaixaDialogoRecarregarTabela()"
                            *ngIf="!camposDesabilitados">
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
            </div>

            <div fxLayout="row" fxFlexFill *ngIf="isEditando" [style.padding]="'5px'" fxLayoutAlign="left"
                 style="margin-top: 10px; margin-bottom: 10px;">
                <div fxFlex="min-content">
                    <button matTooltip="Alterar Largura" mat-mini-fab color="primary" class="botaoAcaoTabela"
                            (click)="abrirDialogLarguraColuna()">
                        <mat-icon>settings</mat-icon>
                        Alterar Largura
                    </button>
                </div>
                <div fxFlex="min-content">
                    <button matTooltip="Editar" mat-mini-fab color="primary" class="botaoAcaoTabela"
                            [disabled]="!cabecalhoSelecionado || !(!cabecalhoSelecionadoSegundo)"
                            (click)="abrirDialogDescricaoCabecalho()">
                        <mat-icon>settings</mat-icon>
                        Editar Celula
                    </button>
                </div>
                <div fxFlex="min-content">
                    <button matTooltip="Deselecionar" mat-mini-fab color="primary" class="botaoAcaoTabela"
                            [disabled]="!cabecalhoSelecionado && !cabecalhoSelecionadoSegundo" (click)="selecionarCelula(null)">
                        <mat-icon>close</mat-icon>
                        Limpar Seleção
                    </button>
                </div>
            </div>
            <div fxLayout="row" fxFlexFill *ngIf="isEditando" [style.padding]="'5px'" fxLayoutAlign="left"
                 style="margin-top: 10px; margin-bottom: 10px;">
                <div fxFlex="min-content">
                    <button matTooltip="Fazer Merge" mat-mini-fab color="primary" class="botaoAcaoTabela"
                            [disabled]="!cabecalhoSelecionado || !cabecalhoSelecionadoSegundo" (click)="mergeCells()">
                        <mat-icon>chevron_right</mat-icon>
                        Fazer Merge de Células
                    </button>
                </div>
            </div>
            <div fxLayout="row">
                <div fxFlexFill>
                    <div [style.padding]="'5px'" fxLayout="row" fxLayoutAlign="center"
                         style="margin-top: 10px; margin-bottom: 10px;">
                        <div style="display: flex; justify-content: center;">
                            <table class="data-table">
                                <tr *ngFor="let linha of linhaTabela">
                                    <ng-container *ngFor="let item of linha">
                                        <td *ngIf="shouldShowCell(item)"
                                            [attr.colspan]="item.extensaoColuna"
                                            [attr.rowspan]="item.extensaoLinha"
                                            [ngClass]="{'selected': isSelected(item),
                                                        'data-cell': item.tipoDado !== 'H' && item.tipoDado !== 'S' && item.tipoDado !== 'O',
                                                        'spacer-cell': item.tipoDado === 'S',
                                                        'editable': isEditando && item.tipoDado !== 'S'
                                                        }"
                                            [ngStyle]="getCellStyles(item)"
                                            (click)="handleCellClick(item)">

                                            <div class="cell-content" *ngIf="item.tipoDado !== 'O'"
                                                 [title]="item.posicaoLinha + '' + item.posicaoColuna"
                                                 [style.text-align]="item.alinhamento === 'L' ? 'left' : item.alinhamento === 'C' ? 'center' : 'right'"
                                                 [style.font-weight]="item.bold ? 'bold' : 'normal'"
                                                 [style.font-style]="item.italic ? 'italic' : 'normal'">
                                                <p innerHTML={{item.descricao}} [style.width]="'100%'"
                                                   [style.margin]="'0px 0px 0px 0px'">{{ item.descricao }}</p>
                                            </div>

                                            <div class="action-buttons" *ngIf="showActionButtons(item)">
                                                <button mat-mini-fab color="primary"
                                                        matTooltip="Adicionar Linha"
                                                        class="action-button add-button"
                                                        (click)="$event.stopPropagation(); chamaCaixaDialogoAdicionarLinha(linha[0])">
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                                <button mat-mini-fab color="primary"
                                                        matTooltip="Remover Linha"
                                                        class="action-button"
                                                        (click)="$event.stopPropagation(); chamaCaixaDialogoRemoverLinha(linha[0])">
                                                    <mat-icon>remove</mat-icon>
                                                </button>
                                            </div>
                                        </td>
                                    </ng-container>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>
</div>
